export default __webpack_public_path__ + "static/media/Adminhotel.6cd0c3df.png";